import { View } from "binder"
import { warehouseFloorSelectorViewModel } from "../warehouseFloorManipulation/warehouseFloorManipulation-viewModel";
import { GetCurrentWarehouseFloorViewModel } from "./getCurrentWarehouseFloor-viewModel"

export class GetCurrentWarehouseFloorView extends View<GetCurrentWarehouseFloorViewModel>{
    GetViewUniqueId(): string {
        return "V-FAFE6975-A341-44BB-BD82-6ADA61EEF743"
    }
    loadHtml(): string {
        let element = require('./getCurrentWarehouseFloor.html').default;
        let style = require('./getCurrentWarehouseFloor.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set FloorSelector(v: warehouseFloorSelectorViewModel) { this._FloorSelector = v; } public get FloorSelector(): warehouseFloorSelectorViewModel { return this._FloorSelector;} private _FloorSelector: warehouseFloorSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    save(){
        this.dataContext.save();
    }

    remove(){
        this.dataContext.remove();
    }

    close(){
        this.dataContext.close();
    }
}
